<ion-app>
  @if (isMenuEnabled()) {
    <ion-split-pane when="(min-width: 992px)" contentId="main" class="app-split-pane">
      <ion-menu
        contentId="main"
        side="start"
        type="reveal"
        [swipeGesture]="isMenuEnabled()"
        menuId="main"
      >
        <app-menu></app-menu>
      </ion-menu>
      <ion-router-outlet id="main"></ion-router-outlet>
    </ion-split-pane>
  } @else {
    <ion-router-outlet id="main"></ion-router-outlet>
  }
</ion-app>
